import { useState } from "react";
import VideoSettingsContext from "./videoSettings.context";
import { VideoSettingsContextType } from "./videoSettings.types";

export const VideoSettingsProvider = ({ children }) => {
  const [isMuted, setIsMuted] = useState<boolean>(true);
  const [isPlayingIntroVideo, setIsPlayingIntroVideo] = useState<boolean>(true);

  const value: VideoSettingsContextType = {
    isMuted,
    setIsMuted,
    isPlayingIntroVideo,
    setIsPlayingIntroVideo,
  };

  return (
    <VideoSettingsContext.Provider value={value}>
      {children}
    </VideoSettingsContext.Provider>
  );
};
